






































import { ROUTER_CONSTS } from '../../router/router.consts';

import EqualizeList from '../equalize/equalize-list.view.vue';

export default {
  name: 'equalize-dashboard-list',
  mixins: [EqualizeList],
  data: function () {
    const messages = this.$epb.messages.tools.equalize;
    return {
      routes: {
        create: ROUTER_CONSTS.routes.equalizeDashboard.create,
        update: ROUTER_CONSTS.routes.equalizeDashboard.update
      },
      columns: [
        {
          id: 'title',
          text: messages.fields.title.label,
          sortable: true
        }, {
          id: 'enabledTime',
          text: messages.fields.enabledTime.label
        }, {
          id: 'meta.updateDate',
          text: messages.fields.updateDate.label,
          sortable: true
        }, {
          id: 'meta.user',
          text: messages.fields.user.label,
          sortable: true
        }, {
          id: 'enabled',
          text: messages.fields.enabled.label,
          sortable: true
        }
      ]
    };
  }
};

